import { useState, useEffect } from "react";
import { fetchAccountInfo } from "../../../services/accountServices";
import CONSTANTS from "../../../Constants/Constants";
import PrivateItineraries from "./itineraries/PrivateItineraries";
import PublicItineraries from "./itineraries/PublicItineraries";
import {  
    fetchItineraryById,
} from "../../../services/agentServices";

const ItineraryPreviewer = (props) => {

    const params = new URLSearchParams(window.location.search);

    const {
        bookingEngine,
    } = props;

    const _SUB_PAGES = {
        view_list: 0,
        view_details: 1,
    }

    const [ currentPage, setCurrentPage ] = useState(_SUB_PAGES?.view_list);
    const [ selectedItinerary, setSelectedItinerary ] = useState({});
    const [ isLoggedIn, setIsLoggedIn ] = useState(false);
    const [ user, setUser ] = useState({});
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isShowSignUpForm, setIsShowSignUpForm ] = useState(false);
    const [ pageFilters, setPageFilters ] = useState({
        category: "",
        status: "",
    });

    const verifyLogin = async (show_create_new_ticket_form=true) => {
        setIsLoading(true);

        if(params.has("public")){
            
        }else{
            let _user=await fetchAccountInfo();
            if(_user._id){
                setUser(_user);
                setIsLoggedIn(true);
                setIsLoading(false);
                
                if(params.has("itin_id") && params.get("itin_id")){
                    setCurrentPage(_SUB_PAGES?.view_details);
                }else{

                }
            }else{
                setIsLoading(false);
                setIsLoggedIn(false);
            }
        }
    }

    useEffect(()=>{
        if(!params.has("public"))
            verifyLogin();
    }, []);
    
    const LogMeIn = () => {
        localStorage.setItem(CONSTANTS.local_storage.logged_in_usr, true);
    }

    const goHomeFunction = () => {
        setSelectedItinerary({});                                               
    }

    const showItineraryList = () => {
        setSelectedItinerary({});
    }

    return <div>
        {
            params.has("public") ? 
            <PublicItineraries 
                bookingEngine={bookingEngine}
                selectedItinerary={selectedItinerary}
                setSelectedItinerary={setSelectedItinerary}
            /> :
            <PrivateItineraries 
                isLoggedIn={isLoggedIn}
                isShowSignUpForm={isShowSignUpForm}
                LogMeIn={LogMeIn}
                setIsShowSignUpForm={setIsShowSignUpForm}
                currentPage={currentPage}
                _SUB_PAGES={_SUB_PAGES}
                pageFilters={pageFilters}
                user={user}
                setSelectedItinerary={setSelectedItinerary}
                setCurrentPage={setCurrentPage}
                selectedItinerary={selectedItinerary}
                bookingEngine={bookingEngine}
            />
        }
        </div>
}

export default ItineraryPreviewer;